import { createAsyncThunk } from "@reduxjs/toolkit"

import store from "../../store"

import {
  downloadCaseZip,
  getCaseByCaseId,
  getCaseByPatientId,
  unarchiveCaseStatus,
  updateCaseByCaseId,
  updateCaseStatusById,
  conversionService,
  caseAction,
  cancelOrder
} from "./case.service"

export const updateCaseStatus = createAsyncThunk(
  "caseService /updateCaseStatus",
  async (
    {
      patientId,
      caseId,
      payload,
      cancelUAssist,  
    }: {
      patientId: string
      caseId: string
      payload?: { case_disposition: string, is_refinement?: boolean, orderId?: string }
      cancelUAssist?: boolean
    },
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return updateCaseStatusById(orgId, patientId, caseId, payload, cancelUAssist)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const updateCaseUnarchive = createAsyncThunk(
  "caseService /updateCaseUnarchive",
  async (
    {
      patientId,
      caseId,
    }: {
      patientId: string
      caseId: string
    },
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return unarchiveCaseStatus(orgId, patientId, caseId)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getCaseById = createAsyncThunk(
  "caseService /getCaseById",
  async (
    {
      patientId,
      caseId,
    }: {
      patientId: string
      caseId: string
      /** Read by loaderSuppressionMiddleware; unused here. */
      trackLoaderKey?: string
    },
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return getCaseByCaseId(orgId, patientId, caseId)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getCaseByPatient = createAsyncThunk(
  "caseService/getCaseByPatient",
  async (
    {
      patientId,
      isCaseArchived,
    }: {
      patientId: string
      isCaseArchived?: boolean
    },
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return getCaseByPatientId(orgId, patientId, isCaseArchived)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const updateCaseById = createAsyncThunk(
  "caseService/updateCaseById",
  async (
    {
      patientId,
      caseId,
      payload,
    }: {
      patientId: string
      caseId: string
      payload: {
        assigned_to?: number
        course_check_number?: number
        txplan_name?: string
        txplan_subname?: string
        case_disposition?: string
        notes?: string
        case_extra_attrs?: string
        udesign_category?: string
        status?: number
        phase?: number
        case_type?: string
        planned_upper?: number
        planned_lower?: number
      }
    },
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await updateCaseByCaseId(orgId, patientId, caseId, payload)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getCaseFilesByCaseId = createAsyncThunk(
  "caseService/getCaseFilesByCaseId",
  async (
    {
      patientId,
      caseId,
    }: {
      patientId: number
      caseId: number
    },
    { rejectWithValue },
  ) => {
    const orgId = store.getState().userService.user.current_orgId
    try {
      return await downloadCaseZip(orgId, patientId, caseId)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)
// conversion thunk
export const conversionThunk = createAsyncThunk(
  "caseService/conversionRequest",
  async (
    {
      patientId,
      caseId,
      payload,
    }: {
      patientId: string
      caseId: string
      payload: { method: string }
    },
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return conversionService(orgId, patientId, caseId, payload)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const caseConversionAction = createAsyncThunk(
  "caseService/caseAction",
  async (
    {
      patientId,
      caseId,
      payload,
    }: {
      patientId: string
      caseId: string
      payload: any
    },
    { rejectWithValue },
  ) => {
    const orgId = store.getState().userService.user.current_orgId
    try {
      return await caseAction(orgId, patientId, caseId, payload)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)
